import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SearchIcon } from '@/shared/assets/icons/search-icon';
import { ClearButton } from '@/shared/components/ui/button/clear-button/clear-button';
import { TextField } from '@/shared/components/ui/form/components/text-field/text-field';
import { ClearSlot } from '@/shared/components/ui/searchbar/searchbar.styled';
import { TSearchbar } from '@/shared/components/ui/searchbar/searchbar.types';

export const Searchbar: React.FC<TSearchbar> = ({
  placeholder,
  width,
  value,
  label,
  onClearSearchbar,
  onSearchbarChange,
  ...rest
}) => {
  const { t } = useTranslation();

  const adornments = {
    startAdornment: <SearchIcon variant="light" />,
    endAdornment: (
      <ClearSlot $visible={Boolean(value)}>
        <ClearButton onClick={onClearSearchbar} />
      </ClearSlot>
    ),
  };

  return (
    <Stack
      width={width}
      gap="1rem"
      onClick={(event) => event.stopPropagation()}
    >
      {label && (
        <Typography variant="h7" color="secondary">
          {t('ui:filter_by_asset_type', {
            assetType: label,
          })}
        </Typography>
      )}
      <TextField
        {...rest}
        fullWidth
        placeholder={placeholder}
        slotProps={{
          input: adornments,
        }}
        value={value}
        onChange={onSearchbarChange}
      />
    </Stack>
  );
};
